import { render, staticRenderFns } from "./CollectionsCustomerPortals.vue?vue&type=template&id=32dc2bb5"
import script from "./CollectionsCustomerPortals.vue?vue&type=script&lang=js"
export * from "./CollectionsCustomerPortals.vue?vue&type=script&lang=js"
import style0 from "./CollectionsCustomerPortals.vue?vue&type=style&index=0&id=32dc2bb5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports